module.exports = __webpack_public_path__ + "img/formulastudent.83bc5e23.jpg";